var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwardReg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3327 37.5832L27.1088 30.1728C26.9363 29.6777 26.6192 29.2457 26.1986 28.9326C25.778 28.6195 25.2732 28.4397 24.7493 28.4165H19.2493C18.7255 28.4397 18.2207 28.6195 17.8001 28.9326C17.3795 29.2457 17.0624 29.6777 16.8898 30.1728L14.666 37.5832",
    stroke: "#2B5CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 28.413V22.9185",
    stroke: "#2B5CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2938 1.70705L26.1153 8.25022H31.6061C31.8832 8.24014 32.1566 8.31576 32.3891 8.46676C32.6216 8.61777 32.8019 8.83681 32.9053 9.09403C33.0088 9.35124 33.0303 9.6341 32.9671 9.90403C32.9039 10.174 32.759 10.4178 32.5521 10.6024L27.7891 14.8502L30.4291 20.9241C30.545 21.2019 30.5708 21.509 30.503 21.8023C30.4352 22.0955 30.2771 22.3601 30.0511 22.5589C29.825 22.7576 29.5423 22.8805 29.2428 22.9102C28.9433 22.9399 28.642 22.8749 28.3813 22.7244L21.9995 19.1292L15.6195 22.7336C15.3579 22.8881 15.0542 22.9559 14.7518 22.9272C14.4494 22.8986 14.1638 22.775 13.9359 22.5742C13.708 22.3734 13.5495 22.1056 13.4831 21.8092C13.4167 21.5128 13.4457 21.2029 13.5661 20.9241L16.2116 14.8502L11.445 10.6061C11.2368 10.4219 11.0906 10.1779 11.0266 9.90749C10.9625 9.63706 10.9836 9.35342 11.0869 9.09545C11.1903 8.83747 11.371 8.61778 11.6041 8.46646C11.8372 8.31515 12.1114 8.23962 12.3891 8.25022H17.8891L20.7051 1.70705C20.8302 1.47239 21.0167 1.27615 21.2447 1.1393C21.4727 1.00246 21.7336 0.930176 21.9995 0.930176C22.2654 0.930176 22.5263 1.00246 22.7543 1.1393C22.9822 1.27615 23.1687 1.47239 23.2938 1.70705Z",
    stroke: "#2B5CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33 40.3335C33 41.0628 32.7103 41.7623 32.1945 42.278C31.6788 42.7938 30.9793 43.0835 30.25 43.0835H13.75C13.0207 43.0835 12.3212 42.7938 11.8055 42.278C11.2897 41.7623 11 41.0628 11 40.3335C11 39.6042 11.2897 38.9047 11.8055 38.389C12.3212 37.8732 13.0207 37.5835 13.75 37.5835H30.25C30.9793 37.5835 31.6788 37.8732 32.1945 38.389C32.7103 38.9047 33 39.6042 33 40.3335Z",
    stroke: "#2B5CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwardReg);
export default __webpack_public_path__ + "static/media/award_reg.7ab7b23863f929660d210c8e8118050d.svg";
export { ForwardRef as ReactComponent };